export class DragData {

  senderKey: string;
  item: any;
}